import getConfig from 'next/config'

const { publicRuntimeConfig } = getConfig()

const server = {
  omsApiV4Endpoint: process.env.OMS_API_V4_ENDPOINT || publicRuntimeConfig.OMS_API_V4_ENDPOINT || 'https://beta.oddle.me',
  v3ApiTarget: process.env.V3_API_TARGET || publicRuntimeConfig.V3_API_TARGET || 'https://beta.oddle.me',
  // customisationBackendBaseUrl:
  //   process.env.CUSTOMISATION_BACKEND_BASE_URL ||
  //   'http://customisation.localhost/api/customisation/v1'
  customisationBackendBaseUrl:
    process.env.CUSTOMISATION_BACKEND_BASE_URL ||
    'https://beta.oddle.me/api/customisation/v1',
  reserveServer:
    process.env.RESERVE_SERVER ||
    'https://reserve-backend-staging.beta.oddle.me',
  cacheExpirationTime: process.env.CACHE_EXPIRATION_TIME || publicRuntimeConfig.CACHE_EXPIRATION_TIME || '600'
}

export default server
